<template>
    <!-- Large Device Layout (md and up) -->
    <v-card v-if="!xs" class="my-4 d-flex align-center" variant="flat">
        <v-card-text>
            <v-list-item class="flex-grow-1">
                <!-- Icon inside green (secondary) circular avatar -->
                <template #prepend>
                    <v-avatar size="36" color="secondary">
                        <v-icon class="white--text" size="20">
                            {{
                                forma ? forma.forma_clasificacion.icono : avatar
                            }}
                        </v-icon>
                    </v-avatar>
                </template>

                <v-list-item-title
                    class="text-h5"
                    style="white-space: normal; word-break: break-word"
                >
                    {{ forma ? forma.nombre : titulo }}
                </v-list-item-title>

                <!-- Deadline for forma type c -->
                <div
                    v-if="forma && forma.fecha_baja_formato"
                    class="text-tertiary text-body-1"
                    style="white-space: normal; word-break: break-word"
                >
                    {{ $t("home.formas.fecha-cierre") }}
                    {{ forma.fecha_baja_formato }}
                </div>

                <!-- Regular description for non-forma usage -->
                <v-list-item-subtitle
                    v-if="!forma && descripcion"
                    style="white-space: normal; word-break: break-word"
                >
                    {{ descripcion }}
                </v-list-item-subtitle>

                <!-- Trailing section: Contact Us with Vendor Avatar (only if forma exists) -->
                <template #append v-if="forma">
                    <div class="d-flex align-center justify-end">
                        <!-- Vendor Contact Menu -->
                        <v-menu
                            v-model="menuAbierto"
                            offset-y
                            max-width="400"
                            :close-on-content-click="false"
                        >
                            <template #activator="{ props }">
                                <div
                                    class="d-flex align-center cursor-pointer"
                                    v-bind="props"
                                >
                                    <v-avatar
                                        size="48"
                                        class="mr-2"
                                        variant="outlined"
                                        color="background"
                                    >
                                        <v-img
                                            :src="forma.usuario.url_logo"
                                            alt="Vendor Logo"
                                            width="40"
                                            height="40"
                                        ></v-img>
                                    </v-avatar>
                                    <div class="d-flex flex-column">
                                        <span class="text-caption grey--text">{{
                                            $t("necesita-ayuda")
                                        }}</span>
                                        <span
                                            class="text-caption text-secondary font-weight-medium"
                                            >{{ forma.usuario.nombre }}
                                            Info
                                        </span>
                                    </div>
                                </div>
                            </template>

                            <v-card width="400">
                                <!-- Header -->
                                <v-card-title class="pb-2">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="text-h6 text--text text-uppercase"
                                            >{{ forma.usuario.nombre }}</span
                                        >
                                        <span
                                            class="text-body-2 text-textLight"
                                            >{{ $t("proveedor.titulo") }}</span
                                        >
                                    </div>
                                </v-card-title>

                                <v-divider></v-divider>

                                <!-- Contact Information (No Tabs) -->
                                <v-card-text style="background-color: #f5f7f8">
                                    <v-list bg-color="background">
                                        <!-- Contact Name -->
                                        <v-list-item
                                            :subtitle="$t('contacto-nombre')"
                                            :title="
                                                forma.usuario.contacto_nombre
                                            "
                                        >
                                            <template v-slot:prepend>
                                                <v-btn
                                                    color="secondary"
                                                    icon="mdi-account-outline"
                                                    variant="text"
                                                ></v-btn>
                                            </template>
                                        </v-list-item>

                                        <!-- Phone -->
                                        <v-list-item
                                            v-if="
                                                forma.usuario.contacto_telefono
                                            "
                                            :subtitle="$t('contacto-telefono')"
                                            :title="
                                                forma.usuario.contacto_telefono
                                            "
                                        >
                                            <template v-slot:prepend>
                                                <v-btn
                                                    color="secondary"
                                                    icon="mdi-phone-hangup-outline"
                                                    variant="text"
                                                ></v-btn>
                                            </template>
                                        </v-list-item>

                                        <!-- Email -->
                                        <v-list-item
                                            v-if="forma.usuario.contacto_correo"
                                            :subtitle="$t('contacto-correo')"
                                            :title="
                                                forma.usuario.contacto_correo
                                            "
                                        >
                                            <template v-slot:prepend>
                                                <v-btn
                                                    color="secondary"
                                                    icon="mdi-email-outline"
                                                    variant="text"
                                                ></v-btn>
                                            </template>
                                            <template v-slot:append>
                                                <v-btn
                                                    color="textLight"
                                                    :icon="
                                                        copiadoTexto[
                                                            forma.usuario
                                                                .contacto_correo
                                                        ]
                                                            ? 'mdi-check'
                                                            : 'mdi-content-copy'
                                                    "
                                                    variant="text"
                                                    @click="
                                                        copiarTexto(
                                                            forma.usuario
                                                                .contacto_correo
                                                        )
                                                    "
                                                ></v-btn>
                                            </template>
                                        </v-list-item>
                                    </v-list>
                                </v-card-text>
                                <v-card-actions
                                    class="d-flex flex-row justify-center"
                                >
                                    <v-btn
                                        variant="outlined"
                                        color="secondary"
                                        @click="menuAbierto = false"
                                    >
                                        {{ $t("boton-cerrar") }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-menu>
                    </div>
                </template>
            </v-list-item>
        </v-card-text>
    </v-card>

    <!-- Extra Small Device Layout (xs only) -->
    <v-card
        v-else
        class="my-4 d-flex flex-column justify-center align-center"
        outlined
        flat
        style="height: 144px"
    >
        <!-- Title -->
        <div class="d-flex justify-center mb-3">
            <span class="text-h5 text-center" style="line-height: 1.2">
                {{ forma ? forma.nombre : titulo }}
            </span>
        </div>

        <!-- Deadline -->
        <div class="d-flex justify-center mb-3">
            <!-- Deadline for forma -->
            <span
                v-if="forma && forma.fecha_baja_formato"
                class="text-body-2 text-tertiary text-center"
            >
                {{ $t("home.formas.fecha-cierre") }}
                {{ forma.fecha_baja_formato }}
            </span>

            <!-- Regular description for non-forma usage -->
            <span v-if="!forma && descripcion" class="text-caption text-center">
                {{ descripcion }}
            </span>
        </div>

        <!-- Contact Us (only if forma exists) -->
        <div v-if="forma" class="d-flex justify-center">
            <v-menu
                v-model="menuAbiertoXs"
                offset-y
                max-width="400"
                :close-on-content-click="false"
            >
                <template #activator="{ props }">
                    <div
                        class="d-flex align-center cursor-pointer"
                        v-bind="props"
                    >
                        <v-avatar
                            size="48"
                            class="mr-2"
                            variant="outlined"
                            color="background"
                        >
                            <v-img
                                :src="forma.usuario.url_logo"
                                alt="Vendor Logo"
                                width="40"
                                height="40"
                            ></v-img>
                        </v-avatar>
                        <div class="d-flex flex-column">
                            <span class="text-caption grey--text">{{
                                $t("necesita-ayuda")
                            }}</span>
                            <span
                                class="text-caption text-secondary font-weight-medium"
                            >
                                {{ forma.usuario.nombre }}
                                Info
                            </span>
                        </div>
                    </div>
                </template>

                <v-card width="320">
                    <!-- Header -->
                    <v-card-title class="pb-2">
                        <div class="d-flex flex-column">
                            <span class="text-h6 text--text text-uppercase">{{
                                forma.usuario.nombre
                            }}</span>
                            <span class="text-body-2 text-textLight">{{
                                $t("proveedor.titulo")
                            }}</span>
                        </div>
                    </v-card-title>

                    <v-divider></v-divider>

                    <!-- Contact Information (No Tabs) -->
                    <v-card-text style="background-color: #f5f7f8">
                        <v-list bg-color="background">
                            <!-- Contact Name -->
                            <v-list-item
                                :subtitle="$t('contacto-nombre')"
                                :title="forma.usuario.contacto_nombre"
                            >
                                <template v-slot:prepend>
                                    <v-btn
                                        color="secondary"
                                        icon="mdi-account-outline"
                                        variant="text"
                                    ></v-btn>
                                </template>
                            </v-list-item>

                            <!-- Phone -->
                            <v-list-item
                                v-if="forma.usuario.contacto_telefono"
                                :subtitle="$t('contacto-telefono')"
                                :title="forma.usuario.contacto_telefono"
                            >
                                <template v-slot:prepend>
                                    <v-btn
                                        color="secondary"
                                        icon="mdi-phone-hangup-outline"
                                        variant="text"
                                    ></v-btn>
                                </template>
                            </v-list-item>

                            <!-- Email -->
                            <v-list-item
                                v-if="forma.usuario.contacto_correo"
                                :subtitle="$t('contacto-correo')"
                                :title="forma.usuario.contacto_correo"
                            >
                                <template v-slot:prepend>
                                    <v-btn
                                        color="secondary"
                                        icon="mdi-email-outline"
                                        variant="text"
                                    ></v-btn>
                                </template>
                                <template v-slot:append>
                                    <v-btn
                                        color="textLight"
                                        :icon="
                                            copiadoTexto[
                                                forma.usuario.contacto_correo
                                            ]
                                                ? 'mdi-check'
                                                : 'mdi-content-copy'
                                        "
                                        variant="text"
                                        @click="
                                            copiarTexto(
                                                forma.usuario.contacto_correo
                                            )
                                        "
                                    ></v-btn>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                    <v-card-actions class="d-flex flex-row justify-center">
                        <v-btn
                            variant="outlined"
                            color="secondary"
                            @click="menuAbiertoXs = false"
                        >
                            {{ $t("boton-cerrar") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-menu>
        </div>
    </v-card>

    <!-- Overlay cuando el menú está abierto - cubre toda la pantalla -->
    <v-overlay
        v-model="menuAbierto"
        scrim="black"
        persistent
        style="z-index: 1999"
    >
    </v-overlay>
    <v-overlay
        v-model="menuAbiertoXs"
        scrim="black"
        persistent
        style="z-index: 1999"
    >
    </v-overlay>
</template>

<script setup>
import { ref } from "vue";
import { useDisplay } from "vuetify";

const props = defineProps({
    titulo: {
        type: String,
        default: "",
    },
    descripcion: {
        type: String,
        default: "",
    },
    avatar: {
        type: String,
        default: "",
    },
    forma: {
        type: Object,
        default: null,
    },
});

const { smAndDown, xs } = useDisplay();
const copiadoTexto = ref({});
const menuAbierto = ref(false);
const menuAbiertoXs = ref(false);

const copiarTexto = async (texto) => {
    try {
        await navigator.clipboard.writeText(texto);
        copiadoTexto.value[texto] = true;
        setTimeout(() => {
            copiadoTexto.value[texto] = false;
        }, 2000);
    } catch (err) {
        console.error("Error al copiar:", err);
    }
};
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
